// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"style_headingWrapper__XLnTr","contentWrapper":"style_contentWrapper__pWvxF"};